import React from "react";

export default function ProjectTable({ projects, onToggleActive, onReassign }) {
  return (
    <div className="mt-10" style={{overflowY: "scroll",maxHeight:"30rem"}}>
      <table className="table-auto mx-auto bg-white rounded-lg">
        <thead className="bg-[#A71D2A] text-black text-sm text-left">
          <tr>
            <th className="p-3">ID</th>
            <th className="p-3">Proyecto</th>
            <th className="p-3">Estado</th>
            <th className="p-3">Reemplazar Por</th>
          </tr>
        </thead>
        <tbody className="text-sm text-gray-500">
          {projects.map((project) => (
            <tr
              key={project.id}
              className="border-b border-gray-200 hover:bg-gray-50 transition"
            >
              <td className="p-2">{project.id}</td>
              <td className="p-2 font-semibold">{project.proyecto}</td>
              <td className="p-2">
                <label className="inline-flex items-center">
                  <input
                    type="checkbox"
                    checked={project.activo}
                    onChange={() => onToggleActive(project.id)}
                    className="form-checkbox h-5 w-5 text-[#A71D2A]"
                  />
                  <span className="ml-2">
                    {project.activo ? "Activo" : "Inactivo"}
                  </span>
                </label>
              </td>
              <td className="p-2">
                <select
                  className="border rounded px-2 py-1 disabled:bg-gray-100"
                  value={project.reemplazar_por || ""}
                  onChange={(e) =>
                    onReassign(project.id, parseInt(e.target.value))
                  }
                  disabled={project.activo}
                >
                  <option value="0">-- SELECCIONE --</option>
                  {projects
                    .filter((p) => p.activo)
                    .map((p) => (
                      <option key={p.id} value={p.id}>
                        {p.proyecto}
                      </option>
                    ))}
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
